import Alert from 'react-bootstrap/Alert'
import styles from './Notification.module.css'
import { notificationMessageSelector } from "../../../hooks/store/getters";
import { setNotificationMessageSelector } from "../../../hooks/store/setters";
import { useAppStore } from "../../../hooks/store/useAppStore";

const  Notification = () => {
   
    const notificationMessage = useAppStore(notificationMessageSelector);
    const setNotificationMessage = useAppStore(setNotificationMessageSelector);
  
    if (!notificationMessage) return null;

    return (
        <div className={styles.alertWrapper}>
            <Alert
                variant="danger" 
                onClose={() => setNotificationMessage("")} 
                dismissible
            >
                <Alert.Heading className={styles.alertTitle}>Form contains errors!</Alert.Heading>
                <p>
                    { notificationMessage }
                </p>
            </Alert>
        </div>
    );
  }

export default Notification
  
 